<template>
  <v-container fluid>
    <div>
      <v-img src="/images/logoletrasmin.png" width="150px" height="150px">
        <template v-slot:placeholder>
          <v-skeleton-loader type="image"/>
        </template>
      </v-img>
      <v-row>
        <v-col cols="12" md="5" justify="end">
          <p>
            {{$t('We offer a unique experience and an entertaining online game center from the most traditional of games to the most modern, where you will find the proposals according to your tastes. We guarantee honesty and security with the prizes.')}}
          </p>
        </v-col>
        <v-row justify-md="center">
          <v-col cols="4">
            <v-btn
                v-for="page in pages" :key="page.id" :to="{ name: 'page', params: { id: page.id + '-' + language } }"
                small
                text
                rounded
                color="primary"
            >
              {{ $t(page.title) }}
            </v-btn>
            <v-btn
                v-for="cpage in contenfulFooterLinks" :key="cpage.sys.id" :to="{ name: 'contentful-page', params: { slug: cpage.fields.slug } }"
                small
                text
                rounded
                color="primary"
            >
              {{ $t(cpage.fields.title) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
    </div>
    <v-divider/>
    <v-row class="text-center">

      <v-col cols="12" class="py-0">
        <v-btn v-for="sn in socialNetwork" :key="sn.id" :href="sn.link.url" text icon color="primary" class="my-0">
          <v-icon class="mx-1">
            {{ sn.icon }}
          </v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" align-self="center" class="mx-auto py-0 flex">
        <v-btn text :to="{ name: 'support'}" class="mx-15">
          {{ $t('Contact us') }}
        </v-btn>
      </v-col>

      <v-col cols="12" class="py-2">
        <span>{{ address }}</span>
      </v-col>
      <v-col cols="12" class="py-2">
        {{ copyright }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {config} from '~/plugins/config'
import {mapState} from 'vuex'
import {loadMessages} from '~/plugins/i18n'
import CountryFlag from 'vue-country-flag'
import {createClient} from 'contentful';

const client = createClient({
  space: '3futqxo7skww',
  accessToken: 'uAqcK5rJ1ZK6kwhK4oiWZ2R8uLCV0WyOOOVxkMhMvGw',
})

export default {
  name: 'FooterMenu',

  components: {CountryFlag},

  data() {
    return {
      language: 'es',
      pages: config('settings.content.footer.menu'),
      socialNetwork: config('settings.content.footer.follow_us.social_network'),
      address: config('settings.content.footer.address'),
      copyright: config('settings.content.footer.copyright'),
      contenfulFooterLinks: []
    }
  },

  computed: {
    ...mapState('lang', [
      'locale',
      'locales'
    ])
  },

  async created() {
    await this.setContenfulFooterLinks()
  },

  methods: {
    flag(locale) {
      return this.locales[locale].flag || locale
    },
    getLocaleLabel(locale){
      this.language = locale;
      if (locale === 'es') return 'Espanol'
      if (locale === 'en') return 'English'
      else return ''
    },
    setLocale(locale) {
      if (this.$i18n.locale !== locale) {
        loadMessages(locale)

        this.$store.dispatch('lang/setLocale', {locale})
      }
    },
    async setContenfulFooterLinks() {
      this.contenfulFooterLinks = await this.getContentfulPages()
    },
    async getContentfulPages() {
      let params = {
        content_type: 'page',
        'fields.site': window.location.hostname,
        'fields.location[in]': 'Homepage Footer Links'
      }

      const entries = await client.getEntries(params);
      if (entries && entries.items[0]) return entries.items
      return []
    }
  }
}
</script>
<style scoped>
.v-list-item__content > * {
  flex: none;
}

.v-sheet.v-list:not(.v-sheet--outlined) {
  /*margin-left: 60px;*/
  background-color: #274492 !important;
}

.v-list-item__content {

  display: block;

}

.v-btn__content {
  color: white !important;
}
</style>
